import { Cloud } from "lucide-react";
import type { CloudflareApplication, CloudflareNavSection } from "./types";

/** Normalize tab label so e.g. `AGENT` and `Agent` share one sidebar group. */
export function normTabKey(tab: string): string {
  return tab.trim().toLowerCase().replace(/\s+/g, " ");
}

export function displayCloudflareTabTitle(normalizedKey: string): string {
  if (!normalizedKey) return "";
  return normalizedKey
    .split(" ")
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(" ");
}

export function buildCloudflareTabGroups(apps: CloudflareApplication[]): Record<string, CloudflareApplication[]> {
  return apps.reduce<Record<string, CloudflareApplication[]>>((acc, app) => {
    const key = normTabKey(app.tab);
    if (!key) return acc;
    if (!acc[key]) acc[key] = [];
    acc[key].push(app);
    return acc;
  }, {});
}

export function buildCloudflareNavSections(
  tabGroups: Record<string, CloudflareApplication[]>,
  embedPathByAppId: Map<string, string>
): CloudflareNavSection[] {
  return Object.entries(tabGroups).map(([tabKey, items]) => ({
    source: "cloudflare",
    id: `cloudflare:${tabKey}`,
    title: displayCloudflareTabTitle(tabKey),
    icon: Cloud,
    isSectionActive: (pathname: string) =>
      items.some((item) => {
        const seg = embedPathByAppId.get(item.id);
        return Boolean(seg && pathname === `/embed/${seg}`);
      }),
    children: items.map((item) => ({
      appId: item.id,
      to: `/embed/${embedPathByAppId.get(item.id) ?? item.id}`,
      label: item.subTab,
      externalUrl: item.url,
      tabName: displayCloudflareTabTitle(tabKey),
      subTab: item.subTab,
    })),
  }));
}
